import React, { MouseEvent } from "react";
import { Dropdown } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import { ActionHandlerFunction } from "@preveil-api";
import { DriveUIActionTypes, WatchedEntryEntity } from "src/common";
import { Icon } from "src/components";

type AllProps = {
    entry: WatchedEntryEntity;
    handleAction: ActionHandlerFunction;
}

function WatchedDropdownComponent(props: AllProps) {
    const { entry, handleAction } = props;
    return <Dropdown as="button" className="pv-dropdown hide-arrow btn btn-icon btn-sm"
        onClick={(e: MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            e.preventDefault();
        }}
        aria-label="More actions..." disabled={false}>
        <Dropdown.Toggle as="span">
            <Icon className="ficon-more-vertical" />
        </Dropdown.Toggle>

        <Dropdown.Menu align="end">
            <Dropdown.Item aria-label="Watched Items"
                data-tooltip-id="dd-tooltip"
                data-tooltip-content="View this item's Recent Changes"
                data-tooltip-place="right"
                onClick={() => handleAction({ actionType: DriveUIActionTypes.Details, params: entry })}>
                <Icon className="icon-history" />Recent Changes
            </Dropdown.Item>
            <Dropdown.Item aria-label="Watched Items"
                data-tooltip-id="dd-tooltip"
                data-tooltip-content="Unwatch this item"
                data-tooltip-place="right"
                onClick={() => handleAction({ actionType: DriveUIActionTypes.Unwatch, params: [entry.id] })}>
                <Icon className="ficon-eye-off" />Unwatch
            </Dropdown.Item>
            <Tooltip
                id="dd-tooltip"
                disableStyleInjection="core"
                closeEvents={{
                    mouseleave: true,
                    blur: true,
                    click: true,
                    dblclick: true,
                    mouseup: true,
                }} />
        </Dropdown.Menu>
    </Dropdown>;
}

export default React.memo(WatchedDropdownComponent);